import React, { lazy, Suspense } from 'react';

const LazyApplicationRegister = lazy(() => import('./ApplicationRegister'));

const ApplicationRegister = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyApplicationRegister {...props} />
  </Suspense>
);

export default ApplicationRegister;
